import { defineField, defineType } from "sanity";
import { SanctuaryPostFields } from "../objects/sanctuaryPost";
import { SanctuaryVideoFieldsDetails } from "../objects/sanctuaryVideo";
import { Caption } from "../objects/sanctuaryCaptions";

export type SanctuaryHealthVideoFields = {
  title: string;
  postId: string;
  mediaId: string;
  language: string;
  videoLanguage: string;
  photoUrl: string;
  approximateTime: number;
  landscapeVideo: SanctuaryVideoFieldsDetails;
  vimeoId?: string;
  captions: Caption[];
  // photo: any;
  script: string;
  post: SanctuaryPostFields;
};

export const sanctuaryHealthVideoType = defineType({
  type: "document",
  name: "sanctuaryHealthVideo",
  title: "Sanctuary Health Video",
  fields: [
    // language
    defineField({
      name: "language",
      type: "string",
      hidden: true,
      validation: (Rule) => Rule.required()
    }),
    // post title
    defineField({
      name: "title",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    // postId
    defineField({
      name: "postId",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    // VideoMedia.id
    defineField({
      name: "mediaId",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    // video-language
    defineField({
      name: "videoLanguage",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    // approximateTime
    defineField({
      name: "approximateTime",
      type: "number",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    //photo url
    defineField({
      name: "photoUrl",
      type: "string",
      readOnly: true
    }),
    // defineField({
    //   name: "photo",
    //   type: "image",
    // }),
    // script (HTML)
    defineField({
      name: "script",
      type: "string",
      readOnly: true
    }),
    // video landscape
    defineField({
      name: "landscapeVideo",
      type: "sanctuaryVideo",
      validation: (Rule) => Rule.required(),
      //readOnly: true,
      options: {
        collapsible: true,
        collapsed: true
      }
    }),
    defineField({
      name: "vimeoId",
      title: "Vimeo ID",
      type: "string",
      validation: (Rule) =>
        Rule.custom((v) => !v || /^\d+$/.test(v) || "Vimeo ID must be numeric"),
      description:
        "Numeric Vimeo video ID. When set, the user-app plays this video via Vimeo instead of Sanctuary. Clear to fall back to the Sanctuary URL."
    }),
    defineField({
      name: "captions",
      type: "sanctuaryCaptions",
      readOnly: true,
      options: {
        collapsible: true,
        collapsed: true
      }
    }),
    // post
    defineField({
      name: "post",
      type: "sanctuaryPost",
      validation: (Rule) => Rule.required(),
      readOnly: true,
      options: {
        collapsible: true,
        collapsed: true
      }
    })
  ]
});
